import { Link } from "react-router-dom";
import { Instagram, Mail, Youtube } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative mt-24 overflow-hidden bg-ink text-cream"
    >
      <div className="mx-auto max-w-6xl px-6 py-20 md:px-12">
        <h2 className="font-display text-6xl leading-[0.9] tracking-tighter md:text-8xl">
          Let&apos;s turn <span className="text-sunset">DMs</span> into
          <br /> checkouts.
        </h2>

        <div className="mt-14 grid gap-10 sm:grid-cols-2 md:grid-cols-6">
          <div className="sm:col-span-2 md:col-span-1">
            <p className="font-display text-xl font-black">Checkout DM</p>
            <p className="mt-3 max-w-xs text-sm text-cream/70">
              The Instagram-native checkout your merchants and buyers already
              know how to use.
            </p>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-cream/60">
              Product
            </p>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link className="hover:text-hotpink" to="/">Home</Link></li>
              <li><Link className="hover:text-hotpink" to="/features">Features</Link></li>
              <li><Link className="hover:text-hotpink" to="/features/instagram-dm-automation">DM Automation</Link></li>
              <li><Link className="hover:text-hotpink" to="/features/instagram-comment-to-dm-automation">Comment-to-DM</Link></li>
              <li><Link className="hover:text-hotpink" to="/features/instagram-story-reply-automation">Story Replies</Link></li>
              <li><Link className="hover:text-hotpink" to="/features/instagram-product-catalog-checkout">Catalog &amp; Checkout</Link></li>
              <li><Link className="hover:text-hotpink" to="/features/instagram-order-management">Order Management</Link></li>
              <li><Link className="hover:text-hotpink" to="/compare">Compare Tools</Link></li>
              <li><Link className="hover:text-hotpink" to="/pricing">Pricing</Link></li>
              <li><Link className="hover:text-hotpink" to="/login">Merchant Login</Link></li>
            </ul>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-cream/60">
              Resources
            </p>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link className="hover:text-hotpink" to="/faq">FAQ</Link></li>
              <li><Link className="hover:text-hotpink" to="/blog">Blog</Link></li>
<li><Link className="hover:text-hotpink" to="/#how">How It Works</Link></li>
<li><Link className="hover:text-hotpink" to="/#features">Features</Link></li>
              <li><Link className="hover:text-hotpink" to="/referral-guide">Refer &amp; Earn</Link></li>
              <li><Link className="hover:text-hotpink" to="/about">About Us</Link></li>
              <li><Link className="hover:text-hotpink" to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-cream/60">
              Guides
            </p>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link className="hover:text-hotpink" to="/help">Help Guide</Link></li>
              <li><Link className="hover:text-hotpink" to="/tabs-guide">Dashboard Tabs</Link></li>
              <li><Link className="hover:text-hotpink" to="/catalog-guide">Catalog</Link></li>
              <li><Link className="hover:text-hotpink" to="/analytics-guide">Analytics</Link></li>
              <li><Link className="hover:text-hotpink" to="/webhooks-guide">Webhooks</Link></li>
            </ul>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-cream/60">
              Legal
            </p>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link className="hover:text-hotpink" to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link className="hover:text-hotpink" to="/security">Security</Link></li>
              <li><Link className="hover:text-hotpink" to="/terms-of-service">Terms of Service</Link></li>
              <li><Link className="hover:text-hotpink" to="/refund-policy">Refund Policy</Link></li>
              <li><Link className="hover:text-hotpink" to="/data-deletion">Data Deletion</Link></li>
            </ul>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-cream/60">
              Get in touch
            </p>
            <div className="mt-4 flex items-center gap-3">
              <a href="https://instagram.com/princejindalai" className="rounded-full border border-white/20 p-2 hover:bg-white/10" aria-label="Instagram" data-testid="footer-instagram">
                <Instagram size={18} />
              </a>
              <a href="mailto:support@checkoutdm.com" className="rounded-full border border-white/20 p-2 hover:bg-white/10" aria-label="Email" data-testid="footer-email">
                <Mail size={18} />
              </a>
              <a href="https://youtube.com/@PrinceJindalAI" className="rounded-full border border-white/20 p-2 hover:bg-white/10" aria-label="YouTube" data-testid="footer-youtube">
                <Youtube size={18} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 text-xs text-cream/60 md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} Checkout DM. Connecting buyers and merchants.</p>
          <p className="tracking-[0.2em]">MADE FOR INSTAGRAM</p>
        </div>
      </div>
    </footer>
  );
}
